import React, { useEffect, useState, useRef } from "react";
import { useHistory } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import api from "~/services/api";
import ApiBullets from "~/services/Bulletins/api";
import apiLapidar from '~/services/Lapidar/api';
import { formatCNPJ, capitalizeFirstLetter, verifyDifferenceTime, checkSubString } from '~/utils/utils';
import { 
  CloseIconContainer,
  ModalContent,
  Title,
  ButtonArea,
  Button,
  ButtonLink,
  BodyContent,
  Caption,
  ImagePush
} from './styles';

export default function NotificationPushModal(props) {
  const host_name = window.location.host;
  const toastId = useRef(null);

  const history = useHistory();
  const dispatch = useDispatch();

  const notificationReducer = useSelector(
    state => state.notificationReducer,
  );

  const [showModal, setShowModal] = useState(false);
  const [notification, setNotification] = useState(null);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };
  const parameters = {
    headers: header,
  };

  useEffect(() => {
    if (notificationReducer.timePush === 0) {
      fetch()
    }
  }, [notificationReducer.activePopup]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (verifyDifferenceTime(notificationReducer.lastVisualizedPush, 0.10)) {
        fetch();
      }
    }, 60000);
    return () => clearInterval(interval);
  }, [notificationReducer.activePopup, notificationReducer.lastVisualizedPush]);

  async function getStoreSummary() {
    try {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem("access_token"),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const externalLoadIdOrStoreId = localStorage.getItem("external_load_id") ? localStorage.getItem("external_load_id") : localStorage.getItem("storeId")
      return await apiLapidar
      .get(`/store/summary?external_load_id=${externalLoadIdOrStoreId}`, parameters)
        .then((res) => {
          localStorage.setItem('category', res.data.rating);
          return res.data.rating;
        })
        .catch((err) => {
          console.err('Error in load summary data - push', err)
          return false
        })
    } catch (error) {
      console.warn("Exceção in load summary - push", error);
      return false
    }
  }

  async function loadDataMe() {
    try {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    return await api
      .get('residential/store/v1/stores/me', parameters)
      .then(res => {
        localStorage.setItem('segment', res.data.resaleSegmentation);
        localStorage.setItem('core', res.data.core);
        localStorage.setItem('market', res.data.market);
        localStorage.setItem('microMarket', res.data.microMarket);
        localStorage.setItem('branch', res.data.branch);
        localStorage.setItem('document', res.data.document);
        localStorage.setItem('state', res.data.address.stateAbbreviation);
        return res.data
      })
      .catch((err) => {
        console.err('Error in load store me - portal', err)
        return false;
      })

    } catch (error) {
      console.warn("Except in load store me - Portal", error);
      return false;
    }
  }

  async function fetchTrackingRead(id) {
    let document = localStorage.getItem('storeDocument');
    if (document && document != 'undefined'){
      document = formatCNPJ(document);
    }

    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/reads',
        {
          bulletinsid: id,
          cnpj: document
        },
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking read - push.", err);
      });
    } catch (error) {
      console.warn("Exceção in read - push.", error);
      return false
    }
  }

  async function fetchTracking(payload) {
    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/calls',
        payload,
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking call - push.", err);
      });
    } catch (error) {
      console.warn("Exceção in tracking - push.", error);
      return false
    }
  }

  async function getPayload() {
    const payload = {
      segment: '',
      market: '',
      nucleus: '',
      micro_market: '',
      lapidar: '',
      branch: '',
      state: '',
      cnpj: ''
    }

    const segment = localStorage.getItem('segment');
    const core = localStorage.getItem('core');
    const market = localStorage.getItem('market');
    const microMarket = localStorage.getItem('microMarket');
    const branch = localStorage.getItem('branch');
    const state = localStorage.getItem('state');
    const document = localStorage.getItem('storeDocument');
    if (segment && core && market && microMarket && branch && state && document){
      payload.segment = capitalizeFirstLetter(segment);
      payload.nucleus = core;
      payload.market = market;
      payload.micro_market = microMarket;
      payload.branch = branch;
      payload.state = state;
      payload.cnpj = formatCNPJ(document);
    } else {
      const responseStore = await loadDataMe();
      if (responseStore){
        payload.segment = capitalizeFirstLetter(responseStore.resaleSegmentation);
        payload.nucleus = responseStore.core;
        payload.market = responseStore.market;
        payload.micro_market = responseStore.microMarket;
        payload.branch = responseStore.branch;
        payload.state = responseStore.address.stateAbbreviation;
        payload.cnpj = formatCNPJ(responseStore.document);
      }
    }
    
    const summary = await getStoreSummary();
    if (summary) {
      payload.lapidar = capitalizeFirstLetter(summary);
    } else {
      payload.lapidar = "Não inscrita";
    }

    return  payload;
  }

  async function fetch() {
    let dataFetched = [];
    dispatch({ type: "SET_LAST_VISUALIZED_PUSH", lastVisualizedPush: new Date() });
    try {
      const payload = await getPayload();

      await api
      .post(
        '/customer-relationship/sitel/v1/popups',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);
        }
      })
      .catch(err => {
        console.log("Error get popup - page portal", err);
      });

      await api
      .post(
        '/customer-relationship/sitel/v1/pushes',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);

          const notification = verifyNotification(res.data.data);
          if (notification) {
            setNotification(notification);
            setTimeout(() => {
              onOpenPush(notification.id);
            }, 7000);
            await fetchTracking(
              {
                bulletinsid: notification.id,
                cnpj: payload.cnpj
              }
            )
          }
        }
      })
      .catch(err => {
        console.log("Error get data in push page", err);
      });

      await api
      .post(
        '/customer-relationship/sitel/v1/banners',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);
        }
      })
      .catch(err => {
        console.log("Error get banner in page portal", err);
      });

      dispatch({ type: "SET_NOTIFICATIONS", notifications: dataFetched });

    } catch (error) {
      console.warn("Exception in get data - portal page", error);
      return false
    }
  }

  const verifyDateValid = (value) => {
    var todaysDate = new Date();

    if (!value.start_date && !value.end_date) return true;
    if (!value.start_date && value.end_date) {
      if (new Date(value.end_date) >= todaysDate) return true;
      return false;
    }
    if (value.start_date && !value.end_date) {
      if (new Date(value.start_date) <= todaysDate) return true;
      return false;
    }
    if (new Date(value.start_date) <= todaysDate && new Date(value.end_date) >= todaysDate) {
      return true;
    }
    return false;
  }

  function verifyNotification(data) {
    if (data.length > 0) {
      const items = data.filter((item) => item.status === 'published');
      const itemsDateValid = items.filter((item) => verifyDateValid(item));
      const notRead = itemsDateValid.filter((item) => item.number_of_read === null || parseInt(item.number_of_read) === 0);
      const recent = notRead.sort((a, b) => new Date(a.date_published) - new Date(b.date_published));
      return recent.at(-1);
    }
    return null;
  }

  function filterNotification(data) {
    if (data.length > 0) {
      const items = data.filter((item) => item.status === 'published');      
      return items;
    }
    return [];
  }

  function orderingNotifications(old, data) {
    const newData = old.concat(data)
    const ordered = newData.sort((a, b) => new Date(a.date_published) - new Date(b.date_published));
    return ordered;
  }

  function removeDuplicated(data) {
    var reduced = [];

    data.forEach((item) => {
        var duplicated  = reduced.findIndex(redItem => {
            return item.id == redItem.id;
        }) > -1;

        if(!duplicated) {
            reduced.push(item);
        }
    });
    return reduced;
  }

  function onOpenPush(id) {
    if (!notificationReducer.activePopup) {
      dispatch({ type: "SET_TIME_PUSH", timePush: notificationReducer.timePush +1 });
      dispatch({ type: "SET_LAST_VISUALIZED_PUSH", lastVisualizedPush: new Date() });
      setShowModal(true);
      if (!notification?.hiperlinks && !notification?.content) {
        fetchTrackingRead(id);
      }
    }
  }

  return (
    showModal && !toast.isActive(toastId.current) && (
      <>
        {toast.success(
          <ModalContent>
            <BodyContent>
              {/* <ImagePush>
                {notification?.cover && (
                  <img src={notification.cover } alt="Cover push" />
                )}
              </ImagePush> */}
              <Title>
                <span>{notification?.title && notification.title}</span>
              </Title>
              <Caption>
                {notification?.caption && notification.caption}
              </Caption>
              {notification?.hiperlinks && (
                <ButtonLink style={{ cursor: 'pointer' }}>
                  <a
                    onClick={() => fetchTrackingRead(notification.id) }
                    href={notification.hiperlinks} 
                    target={checkSubString(notification.hiperlinks, host_name) ? "_self" : "_blank" }
                  >
                    Saiba mais
                  </a>
                  {' '}
                  <i className="fa fa-caret-right fa-lg"  style={{ fontSize: '0.8rem' }} />
                </ButtonLink>
              )}
              {!notification?.hiperlinks && notification?.content && (
                <ButtonLink onClick={() => history.push(`/segmented-comunication-details?id=${notification.id}`)} style={{ cursor: 'pointer' }}>
                  Saiba mais {' '}
                  <i className="fa fa-caret-right fa-lg"  style={{ fontSize: '0.8rem' }} />
                </ButtonLink>
              )}
            </BodyContent>
          </ModalContent>,{
            toastId: ' ',
            containerId: 'push'
          }
        )}
      </>
    )
  );
}
